import { Injectable } from '@angular/core';
declare let ga: Function;
// declare let dataLayer: any;
@Injectable()
export class GoogleAnalyticsEventsService {

  public pageview(url: string) {
    if (typeof ga !== 'undefined') {
      ga('gtm1.set', 'page', url);
      ga('gtm1.send', 'pageview');
    }
  }

  public addItem(items) {
    if (typeof ga !== 'undefined') {
      items.forEach(item => {
        ga('gtm1.ecommerce:addItem', item);
      });
      ga('gtm1.ecommerce:send');
    }
  }

  public addTransaction(transaction) {
    if (typeof ga !== 'undefined') {
      ga('gtm1.require', 'ecommerce');
      ga('gtm1.ecommerce:addTransaction', transaction);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/google-analytics-events.service.ts